/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Pauze_InvoegenInputs */

const nl_planning_rooster_pauze_invoegen = /** @type {(inputs: Planning_Rooster_Pauze_InvoegenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pauze invoegen na ${i?.naam}`)
};

/**

* @param {Planning_Rooster_Pauze_InvoegenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_invoegen = /** @type {((inputs: Planning_Rooster_Pauze_InvoegenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_InvoegenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_invoegen(inputs)
});
export { planning_rooster_pauze_invoegen as "planning.rooster.pauze_invoegen" }